module.exports = __webpack_public_path__ + "assets/img/Goldenbell_bg.a26c803d.png";